<a class="news-banner is-flex is-justify-center bg-blue-10 text-blue is-flex-shrink-0"
  href="https://www.netatmo.com/blog/web-app-a-new-redesigned-interface" target="_blank">
  <app-text class="text-14 is-family-semiBold">
    {{ 'common-app.__WEBAPP_BLOG_ARTICLE_TITLE' | AsyncLang | async }}
  </app-text>
</a>

<app-page>
  <app-page-nav>
    <app-sidebar class="sidebar" role="sidebar"></app-sidebar>
  </app-page-nav>

  <app-page-content class="is-flex is-column gap-24">
    <app-control-page-header></app-control-page-header>
    <app-control-page-body></app-control-page-body>
    <app-control-page-footer></app-control-page-footer>
  </app-page-content>

  <app-page-aside>
    <!-- back button only when we come from old webapp -->
    <app-control-page-sidebar></app-control-page-sidebar>
  </app-page-aside>

</app-page>
